import {Page} from './router-enum'
import {isEmpty, isWxWork} from '@/utils'
import NProgress from 'nprogress'
import cookie from 'js-cookie'

import {getTenantContext} from '@/components/easy'

// const intercept: string[] = [
//     Page.RESET_PWD,
//     Page.STAFF_LIST,
//     Page.ACCOUNT_CENTER_NAV,
//     Page.ACCOUNT_INFO,
//     Page.RESET_MOBILE,
//     Page.STAFF_LIST_EDIT_STAFF,
//     Page.SECURITY_FORCE_OFFLINE,
// ]

const noPermission: string[] = [
    Page.LOGIN,
    Page.EASY_LOGIN,
    //Page.WX_AUTO_LOGIN,
    Page.AGREEMENT,
    Page.LOGOUT,
    //Page.REFRESH_LOGIN,
    Page.RETRIEVE_PASSWORD,
    Page.REGISTER,
    Page.REGISTER_PAST,
    Page.EASY_REGISTER,
    //Page.REGISTER_STAFF,
    Page.REGISTER_SUCCESS,
    // Page.AGREEMENT,

    Page.SUPPORT_LOGIN,
    Page.SUPPORT_REGISTER,
    //Page.SUPPORT_REGISTER_SUCCESS,
    Page.SUPPORT_RETRIEVE_PASSWORD,
    Page.AUTH_CODE_LOGIN,
    "/test"
]

function routerHandls(router) {
    router.beforeEach(async (to, from, next) => {
        NProgress.start()
        // if (to.query.autoLogin === 'true' && isWxWork()) {
        //   window.location.replace(`${WWW.OA_WEB}`)
        //   return
        // }

        const tenantContext = getTenantContext();

        // if (!noPermission.includes(to.path) && from.path === Page.LOGIN) {
        //     await userStore.getPermissions()
        // }
        //检查token
        if (!noPermission.includes(to.path) && !tenantContext.tenantId) {
            next(Page.LOGIN)
        }
        else if (to.path == Page.LOGIN && tenantContext.tenantId) {
            // if (isWxWork()) {
            //   // 应付三方登录审核
            //   window.location.replace(`${WWW.OA_WEB}`)
            //   return
            // }
            //去noPermission页面，但是用户已经登录，都跳转去产品地图
            next(Page.PRODUCT_MAP)
        } else {
            next()
        }
        // if (intercept.includes(to.path) && !isEmpty(token)) {
        //     //检查是否有用户信息，没有则加载
        //     if (isEmpty()) {
        //         next(Page.LOGIN)
        //         return
        //     }
        //     if (userStore.permissions.isErpAccount) {
        //         next(Page.ACCOUNT_CENTER_ERROR_PAGE)
        //         return
        //     }
        //     next()
        // } else if (to.path === Page.LOGIN && token.length !== 0) {
        //     // if (isWxWork()) {
        //     //   // 应付三方登录审核
        //     //   window.location.replace(`${WWW.OA_WEB}`)
        //     //   return
        //     // }
        //     next(Page.PRODUCT_MAP)
        // } else if (to.path === Page.PRODUCT_MAP) {
        //     // if (isWxWork()) {
        //     //   // 应付三方登录审核
        //     //   window.location.replace(`${WWW.OA_WEB}`)
        //     //   return
        //     // }
        //     next()
        // } else {
        //     next()
        // }
    })
    router.afterEach((to, from) => {
        // to and from are both route objects.
        NProgress.done()
    })
}

export default routerHandls
